
import React from "react";
import { BASE_URL } from "../apiEndpoints";
export const SOCKET_URL = BASE_URL;
//console.log("SOCKET_URL", SOCKET_URL);

export const SocketContext = React.createContext(null);

